import React from 'react';
import { FadeIn } from './FadeIn';
import { ShieldCheck, CheckCircle2 } from 'lucide-react';
export function Guarantee() {
  return <section className="py-10 md:py-20 px-5 bg-brand-cream" data-id="element-114">
      <div className="max-w-3xl mx-auto text-center" data-id="element-115">
        <FadeIn data-id="element-116">
          <ShieldCheck className="w-16 h-16 text-yellow-500 mx-auto mb-4" data-id="element-117" />

          <span className="inline-flex items-center gap-1.5 bg-green-100 text-green-700 text-xs font-bold px-3 py-1.5 rounded-full mb-6" data-id="element-118">
            <CheckCircle2 className="w-3.5 h-3.5" data-id="element-119" />
            SIN RIESGO PARA TI
          </span>

          <h2 className="font-serif text-3xl md:text-4xl text-brand-navy font-bold mb-6" data-id="element-120">
            Garantía de Satisfacción de 7 Días
          </h2>

          <p className="font-sans text-lg text-slate-700 leading-relaxed mb-6 max-w-2xl mx-auto" data-id="element-121">
            Si en 7 días no ves resultados reales en el comportamiento de tus
            hijos, envíanos un correo y te devolvemos tus $7 de inmediato.
          </p>

          <p className="font-sans text-lg text-brand-navy font-bold mb-8" data-id="element-122">
            Sin preguntas. Sin formularios. El riesgo es 100% nuestro.
          </p>

          <div className="w-16 h-px bg-slate-300 mx-auto mb-8" data-id="element-123" />

          <p className="font-serif text-xl md:text-2xl text-brand-navy/70 italic" data-id="element-124">
            "La meta no es una casa perfecta, es una casa con más caminos de
            regreso a la calma."
          </p>
        </FadeIn>
      </div>
    </section>;
}